import application from 'application/application';
// import angular from 'angular';
// import moment from 'moment';
const controller = 'SubPoenaController';

application
	.controller(controller, [
		'$scope',
		'$rootScope',
		'$http',
		'$state',
		'$stateParams',
	'$timeout',
	'API',
	'helper',
	'ngNotify',
	'notification',
	'permissions',
	(
		$scope,
		$rootScope,
		$http,
		$state,
		$stateParams,
		$timeout,
		API,
		helper,
		ngNotify,
		notification,
		permissions
	) => {
		const notifyDanger = message => notification.danger(message);

		const featurePermissions = {
			agenda: permissions.get('schedule'),
			processes: permissions.get('processes'),
			publications: permissions.get('publications'),
			subpoena: permissions.get('subpoena')
			};

			$scope.groupUserSelected = JSON.parse(
				localStorage.getItem('__groupSelected__')
			);

			$scope.groupData = JSON.parse(localStorage.getItem('__groupUserData__'));

			$scope.userData = JSON.parse(
				localStorage.getItem('__authenticationUserData__')
			);

			$scope.accessRecords = helper.responseStore();

			$scope.blockQRCode = true;

			$scope.listHidden = true;

			$scope.hasNotAccessRecords = false;

			$scope.quantityPerPage = Number(sessionStorage.getItem('__qtd__')) || 10;

			let page = sessionStorage.getItem('page');

			$scope.atualPage = page;

			$scope.newCatch = [];

			$scope.judicialOrgansModal = helper.responseStore();
			$scope.systemJudicialModal = helper.responseStore();

			$scope.accessToUpdate;
			$scope.tipoAcessoFonte = [];

			$scope.showA3InfoPopup = false;

			$scope.inputType1 = 'password';
			$scope.isUpdateAccessActive = false;

			$scope.dontShowAgainCheckbox = false;

			$scope.stageCertificate = 0;
			$scope.selectedAccessType = '';

			$scope.creditPlanPromise = null;

			const blocked = localStorage.getItem('__authenticationUserBlocked__');

			featurePermissions.processes.update().then(() => {
				if (blocked == 'true') return $state.go('root.default.blockedUser');

				if (!featurePermissions.subpoena.has('createSubpoena'))
					return $state.go('root.default.publications');
			});

			/**
			 * Verifica se existe uma página anterior à atual.
			 */
			$scope.hasMovementsPrevPage = () =>
				($stateParams.paginaAtual ? +$stateParams.paginaAtual : 1) > 1;

			/**
			 * Navega para a primeira página.
			 */
			$scope.recordMovementsFirstPage = () => {
				let params = helper.cloneSimpleObject($stateParams);

				params.paginaAtual = 1;

				$state.go($state.current.name, params, { inherit: false });
			};

			/**
			 * Navega para a ultima página.
			 */
			$scope.recordMovementsLastPage = () => {
				let params = helper.cloneSimpleObject($stateParams);

				params.paginaAtual = $scope.publicationsPagesLength;

				$state.go($state.current.name, params, { inherit: false });
			};

			/**
			 * Navega para a página anterior.
			 */
			$scope.recordMovementsPrevPage = () => {
				let params = helper.cloneSimpleObject($stateParams);

				let currentPage = params.paginaAtual ? Number(params.paginaAtual) : 1;

				params.paginaAtual = currentPage > 1 ? currentPage - 1 : 1;

				$state.go($state.current.name, params, { inherit: false });
			};

			/**
			 * Navega para a próxima página.
			 */
			$scope.recordMovementsNextPage = () => {
				let params = helper.cloneSimpleObject($stateParams);

				params.paginaAtual = params.paginaAtual
					? Number(params.paginaAtual) + 1
					: 2;

				$state.go($state.current.name, params, { inherit: false });
			};

			$scope.toggleA3InfoPopup = () => {
				$scope.showA3InfoPopup = !$scope.showA3InfoPopup;
			};

			$scope.fileChanged = function(element) {
				$scope.$apply(function() {
					let file = element.files[0];

					if (file) {
						const validExtensions = ['p12', 'pfx'];
						const fileExtension = file.name
							.split('.')
							.pop()
							.toLowerCase();

						const resetCertificateInput = () => {
							$scope.newCatch.CDigital = null;
							document.querySelector('.file-input').value = '';
							element.value = '';
						};

						if (!validExtensions.includes(fileExtension)) {
							notifyDanger(
								'Tipo de arquivo inválido! Apenas arquivos .p12 ou .pfx são permitidos.'
							);
							resetCertificateInput();

							return;
						}

						// Verifica se o nome do arquivo tem mais de 300 caracteres
						if (file.name.length > 300) {
							notifyDanger(
								'O nome do arquivo não pode ter mais de 300 caracteres.'
							);
							resetCertificateInput();

							return;
						}

						// Remove o arquivo anterior, se existir
						$scope.newCatch.CDigital = null;

						// Atribui o novo arquivo
						$scope.newCatch.CDigital = file;

						// Atualiza o campo de exibição do nome do arquivo
						document.querySelector('.file-input').value = file.name;
					}
				});
			};

			function invalidarInput() {
				let input = document.getElementById('senhaCDigital');

				// Adiciona a classe de erro para estilização (opcional)
				input.classList.add('is-invalid');

				// Dispara a validação
				input.reportValidity();
			}

			$scope.changeKey = () => {
				if (
					Boolean(
						$scope.oldCertificate &&
							($scope.oldCertificate.senha != $scope.newCatch.senhaCDigital ||
								$scope.oldCertificate.name != $scope.newCatch.CDigital.name)
					)
				)
					$scope.invalidCertificate = false;
				else $scope.invalidCertificate = true;

				if ($scope.invalidCertificate) invalidarInput();
			};

			$scope.getInvalidCertificate = () => {
				if (
					!(
						(Array.isArray($scope.tipoAcessoFonte) &&
							$scope.tipoAcessoFonte.includes(-3)) ||
						$scope.tipoAcessoFonte == -3
					)
				)
					return;

				let invalid = Boolean(
					$scope.oldCertificate &&
						$scope.oldCertificate.senha == $scope.newCatch.senhaCDigital &&
						$scope.oldCertificate.name == $scope.newCatch.CDigital.name
				);

				$scope.invalidCertificate = true;

				return invalid && $scope.invalidCertificate;
			};

			$scope.analizeError = status => {
				let messageError = status.erros && status.erros[0].mensagem;

				if (messageError.includes('senha')) {
					$scope.invalidCertificate = true;

					$scope.oldCertificate = {
						name: $scope.newCatch.CDigital.name,
						senha: $scope.newCatch.senhaCDigital
					};

					invalidarInput();
				}
			};

			$scope.registerDigitalCertificate = () => {
				$scope.loadingCertificate = true;

				// Criar um objeto FormData
				let formData = new FormData();

				formData.append('NomeArquivo', $scope.newCatch.CDigital.name);
				formData.append('SenhaCertificado', $scope.newCatch.senhaCDigital);
				formData.append('Files', $scope.newCatch.CDigital);

				$http({
					...helper.http(API.subpoena, 'cadastrarCertificado'),
					method: 'POST',
					data: formData,
					headers: { 'Content-Type': undefined } // Deixe o navegador definir corretamente
				})
					.then(({ data }) => {
						let certificate = data.itens[0];

						$scope.stageCertificate = 2;
						$scope.loadingCertificate = false;
						$scope.idCertificadoA1Cliente = certificate.idCertificadoA1Cliente;
						$scope.oldCertificate = null;
					})
					.catch(({ data }) => {
						$scope.loadingCertificate = false;
						$scope.oldCertificate = null;
						$scope.analizeError(data.status);
					})
					.finally(() => {
						$scope.loadingCertificate = false;
						$scope.recordCreditPlan();
					});
			};

			$scope.returnTooltip = (processes, number) => {
				let processesTooltip = number ? number + '\n' : '';

				processes
					.filter(
						process =>
							process.numeroProcesso.replace(/[^0-9]/g, '') !=
							number.replace(/[^0-9]/g, '')
					)
					.map((process, index) => {
						processesTooltip += process.numeroProcesso.replace(
							/(\d{7})(\d{2})(\d{4})(\d{1})(\d{2})(\d{4})/,
							'$1-$2.$3.$4.$5.$6'
						);

						processesTooltip += index < processes.length - 1 ? '\n' : '';
					});

				return processesTooltip;
			};

			$scope.recordJudicialBranches = (responseStore, more, pesq) => {
				$scope.loadingJudicial = true;

				// const paginaAtual =
				// 	more == 'mais' ? $scope.pageJudicialBranches.paginaAtual + 1 : 1;

				$http({
					...helper.http(API.subpoena, 'consultaOrgao'),
					method: 'GET',
					params: {
						...helper.httpFields(['*']),
						ativo: true,
						idGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null,
						idUsuarioCliente: !$scope.groupUserSelected
							? $scope.userData.idUsuarioCliente
							: null,
						paginaAtual: 1,
						registrosPorPagina: 999
					}
				})
					.then(response => {
						// more == 'mais'
						// 	? responseStore.items.push(...response.data.itens)
						responseStore.setItems(response.data.itens);

						if (more != 'modal') {
							// $scope.pageJudicialBranches = response.data.paginacao;

							// if (
							// 	$scope.pageJudicialBranches.paginaTotal > 1 &&
							// 	$scope.pageJudicialBranches.paginaAtual !==
							// 		$scope.pageJudicialBranches.paginaTotal
							// )
							// 	$scope.moreJudicial = true;

							if ($stateParams.orgaoJudicial) {
								const judicial = response.data.itens.filter(
									judi => judi.idOrgaoJudiciario == $stateParams.orgaoJudicial
								);

								if (judicial.length)
									if (judicial[0].siglaOrgao != $scope.titleCourts) {
										$scope.titleCourts = judicial[0].siglaOrgao;
										$scope.cloneFilter.nomeJudicial = judicial[0].siglaOrgao;
									}
							}

							if (pesq && !response.data.itens.length) {
								$scope.notCourts = true;
							} else if (pesq && response.data.itens.length) {
								$scope.notCourts = false;
							}
						}
					})

					.finally(() => {
						$scope.loadingJudicial = false;
						responseStore.setReady(true);
					});
			};

			/* GET de quantidade de itens por pagina */

			$scope.recordItemsPerPageQuantity = () => {
				$http({
					...helper.http(API.parametersUsers, 'GET'),
					params: {
						...helper.httpFields(['*'])
					},
					messageOverride: {
						success() {}
					}
				})
					.then(response => {
						if (response.data.itens && response.data.itens.length > 0) {
							$scope.quantityPerPage =
								response.data.itens[0].qtdRegistroMovPorPagina;
							$scope.idQtdItensPagina =
								response.data.itens[0].idParamUsuarioProdAdv;
						} else $scope.quantityPerPage = 20;
					})

					.finally(() => {
						$scope.consultAccesses($scope.accessRecords);
					});
			};

			$scope.recordItemsPerPageQuantity();

			$scope.updateQuantityPerPage = quantityPerPage => {
				$scope.listHidden = true;
				$scope.atualPage = 1;

				if ($scope.idQtdItensPagina) {
					$http({
						...helper.http(API.parametersUsers),
						method: 'PUT',
						data: {
							itens: [
								{
									id: $scope.idQtdItensPagina,
									qtdRegistroMovPorPagina: quantityPerPage || 20
								}
							]
						},
						messageOverride: {
							success() {}
						}
					}).then(() => {
						$scope.quantityPerPage = quantityPerPage;
						$scope.atualPage = 1;
						$scope.consultAccesses($scope.accessRecords);
					});
				} else {
					$http({
						...helper.http(API.parametersUsers),
						method: 'POST',
						data: {
							itens: [
								{
									qtdRegistroMovPorPagina: quantityPerPage || 20
								}
							]
						},
						messageOverride: {
							success() {}
						}
					}).then(() => {
						$scope.quantityPerPage = quantityPerPage;
						$scope.atualPage = 1;
						$scope.consultAccesses($scope.accessRecords);
					});
				}
			};

			$scope.consultAccesses = (responseStore, paramsPage) => {
				responseStore.setReady(false);

				if (paramsPage) {
					$scope.atualPage = $scope.atualPage - 1;
				}

				$http({
					...helper.http(API.subpoena, 'consultaAcessos'),
					method: 'GET',
					params: {
						...helper.httpFields(['*']),
						idUsuarioCliente: $scope.userData.idUsuarioCliente,
						idGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null,
						paginaAtual: $scope.atualPage ? $scope.atualPage : 1,
						registrosPorPagina: $scope.quantityPerPage
					}
				})
					.then(response => {
						$scope.pagination = response.data.paginacao;

						sessionStorage.setItem('page', response.data.paginacao.paginaAtual);

						responseStore.setItems(response.data.itens);

						if (!response.data.itens.length) {
							$scope.hasNotAccessRecords = true;
						}

						$scope.checkedElement();
					})
					.finally(() => {
						responseStore.setReady(true);

						$scope.listHidden = false;

						setTimeout(() => {
							$scope.setColorElement();
						}, 50);
					});
			};

			$scope.activeInactiveAccess = responseStore => {
				if ($scope.loadingActiveInactive) return;

				$scope.loadingActiveInactive = true;

				let data = {
					idPesqIntimacaoUsCliente: responseStore.idPesqIntimacao
				};

				const api =
					responseStore.sitPesqIntimacaoUsCliente == 'Ativo'
						? 'inativar'
						: 'ativar';

				$http({
					...helper.http(API.subpoena, api),
					method: 'PUT',
					data: data
				})
					.then(() => {
						$scope.checkedElement(
							responseStore,
							responseStore.sitPesqIntimacaoUsCliente == 'Ativo'
								? 'Inativo pelo usuário'
								: 'Ativo'
						);
					})
					.finally(() => {
						$scope.loadingActiveInactive = false;
						setTimeout(() => {
							$scope.onMouseExit(responseStore.idPesqIntimacao);
						}, 50);
						$scope.closeModal('#modalChangeAccessStatus');
					});
			};

			$scope.deleteAccess = responseStore => {
				$scope.loadingDeleteAccess = true;

				let data = {
					idPesqIntimacaoUsCliente: responseStore.idPesqIntimacao
				};

				$http({
					...helper.http(API.subpoena, 'excluirPesquisa'),
					method: 'PUT',
					data: data
				})
					.then(() => {
						$('#modalDeleteAccess').modal('hide');

						$scope.loadingDeleteAccess = false;

						$scope.recordCreditPlan();

						if (
							$scope.accessRecords.items.length == 1 &&
							$scope.pagination.paginaAtual > 1
						) {
							$scope.consultAccesses($scope.accessRecords, true);
						} else {
							$scope.consultAccesses($scope.accessRecords, false);
						}
					})
					.finally(() => {
						$scope.loadingDeleteAccess = false;
					});
			};

			$scope.closeModal = id => {
				$(id).modal('hide');
			};

			$scope.checkedElement = (response, ativo) => {
				if (!response)
					$scope.accessRecords.getItems().forEach(element => {
						if (element.sitPesqIntimacaoUsCliente == 'Ativo')
							element.checked = true;

						if (element.idSitPesqIntimacaoUsCliente == -3)
							element.checked = false;
					});
				else if (response) {
					$scope.accessRecords.getItems().forEach(element => {
						if (response.idPesqIntimacao === element.idPesqIntimacao) {
							element.checked = !element.checked;
							element.sitPesqIntimacaoUsCliente = ativo;
						}
					});
				}
			};

			$scope.setColorElement = () => {
				$scope.accessRecords.getItems().forEach((access, index) => {
					var element = document.getElementById(`classificacao-${index}`);

					if (element && element.style) {
						element.style.color = access.corFundo ? access.corFundo : '#ff5800';
					}
				});
			};

			$scope.openGenericModal = (access, id) => {
				$scope.excluirAccess = access;
				$scope.accessToUpdate = access;
				$scope.isUpdateAccessActive =
					access.sitPesqIntimacaoUsCliente == 'Ativo';

				$(id).modal('show');
			};

			function getCachedCreditPlan() {
				const cache = localStorage.getItem('__creditPlan__');

				if (cache) {
					const parsed = JSON.parse(cache);
					const now = Date.now();

					if (now - parsed.timestamp < 10 * 60 * 1000) {
						return parsed.data;
					}
				}

				return null;
			}

			function setCachedCreditPlan(data) {
				localStorage.setItem(
					'__creditPlan__',
					JSON.stringify({
						timestamp: Date.now(),
						data
					})
				);
			}

			function loadCreditPlan($http, helper, API) {
				if ($scope.creditPlanPromise) return $scope.creditPlanPromise;

				const cached = getCachedCreditPlan();

				if (cached) return Promise.resolve(cached);

				$scope.creditPlanPromise = $http({
					...helper.http(API.userClientFunctionalities, 'GET'),
					params: {
						idFuncionalidade: -72
					}
				})
					.then(response => {
						const item = response.data.itens[0];

						setCachedCreditPlan(item);

						return item;
					})
					.finally(() => {
						$scope.creditPlanPromise = null;
					});

				return $scope.creditPlanPromise;
			}

			$scope.recordCreditPlan = () => {
				$scope.creditPlanLoading = true;

				loadCreditPlan($http, helper, API)
					.then(item => {
						$scope.creditPlan = item;
					})
					.finally(() => {
						$scope.creditPlanLoading = false;
					});
			};

			$scope.recordCreditPlan();

			$scope.paginationAccessRecords = toWhere => {
				$scope.listHidden = true;

				let paginaAtual = $scope.pagination.paginaAtual;

				if (toWhere == 'first') paginaAtual = 1;
				else if (toWhere == 'last') paginaAtual = $scope.pagination.paginaTotal;
				else if (toWhere == 'prev') {
					let currentPage = paginaAtual ? Number(paginaAtual) : 1;

					paginaAtual = currentPage > 1 ? currentPage - 1 : 1;
				} else if (toWhere == 'next')
					paginaAtual = paginaAtual ? Number(paginaAtual) + 1 : 2;

				$scope.atualPage = paginaAtual;

				$scope.consultAccesses($scope.accessRecords);
			};

			$scope.onMouseEnter = buttonId => {
				if ($(`#id-pesq-${buttonId}`)[0].classList.contains('active-button')) {
					$(`#id-pesq-text-${buttonId}`)[0].innerText = 'Inativar';
					$(`#id-pesq-svg-${buttonId}`)[0].innerHTML =
						'<path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q54 0 104-17.5t92-50.5L228-676q-33 42-50.5 92T160-480q0 134 93 227t227 93Zm252-124q33-42 50.5-92T800-480q0-134-93-227t-227-93q-54 0-104 17.5T284-732l448 448Z" />';
					$(`#id-pesq-svg-${buttonId}`)[0].classList.add('svg-white');
				}

				if (
					$(`#id-pesq-${buttonId}`)[0].classList.contains('inactive-button')
				) {
					$(`#id-pesq-text-${buttonId}`)[0].innerText = 'Ativar';
					$(`#id-pesq-svg-${buttonId}`)[0].innerHTML =
						'<path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />';
					$(`#id-pesq-svg-${buttonId}`)[0].classList.add('svg-white');
				}
			};

			$scope.onMouseExit = buttonId => {
				if ($(`#id-pesq-${buttonId}`)[0].classList.contains('active-button')) {
					$(`#id-pesq-text-${buttonId}`)[0].innerText = 'Ativo';
					$(`#id-pesq-svg-${buttonId}`)[0].innerHTML =
						'<path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />';
					$(`#id-pesq-svg-${buttonId}`)[0].classList.remove('svg-white');
				}

				if (
					$(`#id-pesq-${buttonId}`)[0].classList.contains('inactive-button')
				) {
					$(`#id-pesq-text-${buttonId}`)[0].innerText = 'Inativo';
					$(`#id-pesq-svg-${buttonId}`)[0].innerHTML =
						'<path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q54 0 104-17.5t92-50.5L228-676q-33 42-50.5 92T160-480q0 134 93 227t227 93Zm252-124q33-42 50.5-92T800-480q0-134-93-227t-227-93q-54 0-104 17.5T284-732l448 448Z" />';
					$(`#id-pesq-svg-${buttonId}`)[0].classList.remove('svg-white');
				}
			};

			$scope.cleanCertificadoRequired = () => {
				var formElements = document.getElementsByName('createCatch');

				if (formElements.length > 0) {
					var form = formElements[0];

					var formController = window.angular.element(form).controller('form');

					if (formController) {
						formController.$setPristine();
						formController.$setUntouched();
						formController.$submitted = false;
					}
				}
			};

			$scope.closeModalAccess = () => {
				$('#modalCreateCatch').modal('hide');

				$scope.cleanCertificadoRequired();

				$scope.systemJudicialModal.ready = false;

				$scope.catchSuccess = false;

				$scope.changelogin = false;
				$scope.changePassword = false;

				$scope.newCatch = [];

				$('input,textarea,select')
					.filter(
						(index, input) => input.form && input.form.name === 'createCatch'
					)
					.removeClass('is-invalid is-valid');

				$('#createCatchCourt').val('');

				setTimeout(() => {
					$('#createCatchCourt').triggerHandler('change');

					$scope.systemJudicialModal.setItems([]);

					// location.reload();
				}, 300);
			};

			$scope.modalCaptura = () => {
				$scope.blockQRCode = true;
				$scope.newCatch.nomeResponsavel = $scope.userData.nome;

				$('input,textarea,select')
					.filter(
						(index, input) => input.form && input.form.name === 'createCatch'
					)
					.removeClass('is-invalid is-valid');
				$scope.selectedAccessType = '';
				$scope.sourceQty = 0;

				if ($scope.judicialOrgansModal.hasNotItems())
					$scope.recordJudicialBranches($scope.judicialOrgansModal, 'modal');

				$('#modalCreateCatch')
					.modal('show')
					.on('hidden.bs.modal', () => {
						$scope.tipoAcessoFonte = [];
						$scope.stageCertificate = 0;
						$scope.oldCertificate = null;
						$scope.invalidCertificate = false;

						$scope.closeModalAccess();
					});
			};

			$scope.closeModalComponentAccess = () => {
				$('#modalCreateCatch').modal('hide');

				$scope.sourceQty = 0;
				if ($scope.catchSuccess) {
					$scope.consultAccesses($scope.accessRecords);
				}
			};

			$scope.changeCheckboxDontShowAgain = () => {
				$scope.dontShowAgainCheckbox = !$scope.dontShowAgainCheckbox;
			};

			$scope.closeSuccessModal = () => {
				if ($scope.dontShowAgainCheckbox) {
					localStorage.setItem('__dontShowSuccessRegisterModalAgain__', true);
				} else {
					localStorage.setItem('__dontShowSuccessRegisterModalAgain__', false);
				}

				$scope.closeModalComponentAccess();
			};

			$scope.postNewAccess = () => {
				if (
					(($scope.tipoAcessoFonte.length &&
						$scope.tipoAcessoFonte.includes(-3)) ||
						$scope.tipoAcessoFonte == -3) &&
					$scope.stageCertificate == 1
				) {
					$scope.registerDigitalCertificate();

					return false;
				} else if (
					(Array.isArray($scope.tipoAcessoFonte) &&
						$scope.tipoAcessoFonte.includes(-3)) ||
					$scope.tipoAcessoFonte == -3
				)
					$scope.stageCertificate = 2;

				$scope.loadingNewAccess = true;

				let dados = {
					...$scope.newCatch,
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null,
					idUsuarioCliente: !$scope.groupUserSelected
						? $scope.userData.idUsuarioCliente
						: null
				};

				if (
					(Array.isArray($scope.tipoAcessoFonte) &&
						$scope.tipoAcessoFonte.includes(-3)) ||
					$scope.tipoAcessoFonte == -3
				) {
					dados.senha = $scope.newCatch.senhaCDigital;
					dados.idCertificadoA1Cliente = $scope.idCertificadoA1Cliente;

					delete dados.senhaCDigital;
					delete dados.CDigital;
				}

				if (dados.autenticacao === '') delete dados.autenticacao;

				$http({
					...helper.http(API.subpoena, 'POST'),
					data: dados
				})
					.then(() => {
						$('input,textarea,select')
							.filter(
								(index, input) =>
									input.form && input.form.name === 'createCatch'
							)
							.removeClass('is-invalid is-valid');

						let dontShowSuccessRegisterModalAgain = localStorage.getItem(
							'__dontShowSuccessRegisterModalAgain__'
						);

						if (
							dontShowSuccessRegisterModalAgain == null ||
							dontShowSuccessRegisterModalAgain == undefined ||
							dontShowSuccessRegisterModalAgain == false ||
							dontShowSuccessRegisterModalAgain == 'false'
						) {
							$scope.catchSuccess = true;
						} else {
							$scope.closeModalComponentAccess();
							$scope.consultAccesses($scope.accessRecords);
						}

						$scope.newCatch = [];

						if ($rootScope.hasNotAccessSubpoena) {
							$rootScope.hasNotAccessSubpoena = false;
						}
					})
					.finally(() => {
						$scope.loadingNewAccess = false;
						$scope.recordCreditPlan();
					});
			};

			$scope.recordSystem = (responseStore, id) => {
				if (!id && (!$scope.filter || !$scope.filter.orgaoJudicial))
					return false;

				$scope.loadingSystem = true;

				$http({
					...helper.http(API.subpoena, 'consultaFonte'),
					params: {
						...helper.httpFields(['*']),
						idOrgaoJudiciario: !id ? $scope.filter.orgaoJudicial : id,
						idGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null,
						idUsuarioCliente: !$scope.groupUserSelected
							? $scope.userData.idUsuarioCliente
							: null,
						paginaAtual: 1,
						registrosPorPagina: 999
					}
				})
					.then(response => {
						responseStore.setItems(response.data.itens);

						$scope.tipoAcessoFonte = [];
						$scope.selectedAccessType = '';
						$scope.listaFontes = response.data.itens;

						if (!id)
							if ($stateParams.sistema) {
								const sistema = response.data.itens.filter(
									judi => judi.nomeExibicao == $stateParams.sistema
								);

								if ($scope.titleSystem != sistema[0].nomeExibicao) {
									$scope.titleSystem = sistema[0].nomeExibicao;
								}
							}

						if (!response.data.itens.length) $scope.notSystem = true;
						else if (response.data.itens.length) $scope.notSystem = false;
					})

					.finally(() => {
						$scope.loadingSystem = false;
						$scope.cleanCertificadoRequired();
						responseStore.setReady(true);
					});
			};

			$scope.recordTribunalSystemCode = id => {
				let font = $scope.listaFontes.find(f => f.idFonteXTipoPesquisa == id);

				if (!font) {
					$scope.stageCertificate = 1;
					$scope.sourceQty = 0;
					$scope.sourceItems = [];
					$scope.tipoAcessoFonte = [];
					$scope.cleanCertificadoRequired();

					return;
				}

				$scope.stageCertificate = 1;

				if (
					font.fonteTipoPesquisaIntimacoes &&
					font.fonteTipoPesquisaIntimacoes.length
				) {
					$scope.sourceQty = font.fonteTipoPesquisaIntimacoes.length;
					$scope.sourceItems = font.fonteTipoPesquisaIntimacoes;

					if (font.fonteTipoPesquisaIntimacoes.length > 1) {
						$scope.tipoAcessoFonte = [];
						$scope.selectedAccessType = '';
					} else {
						var intimacao = font.fonteTipoPesquisaIntimacoes[0];
						const accessId =
							intimacao && intimacao.idTipoAcessoFontePesq
								? intimacao.idTipoAcessoFontePesq
								: 0;

						$scope.selectedAccessType = accessId;
						$scope.AccessType(accessId);
					}
				} else {
					$scope.sourceQty = 0;
					$scope.sourceItems = [];
					$scope.tipoAcessoFonte = [];
				}

				$scope.cleanCertificadoRequired();
			};

			$scope.isInvalidCadastrar = () => {
				return $scope.tipoAcessoFonte && $scope.tipoAcessoFonte.length == 0;
			};

			$scope.AccessType = function(selectedValueAccess) {
				let selectedItem = $scope.sourceItems.find(
					item => item.idTipoAcessoFontePesq === selectedValueAccess
				);

				if (selectedItem && selectedItem.idTipoAcessoFontePesq == -1) {
					$scope.tipoAcessoFonte = [];
					$scope.tipoAcessoFonte.push(-1);

					$timeout(function() {
						var userLogin = document.getElementById('createCatchLogin');

						if (userLogin) {
							userLogin.focus();
						}
					});
				} else if (selectedItem && selectedItem.idTipoAcessoFontePesq == -2) {
					$scope.tipoAcessoFonte = [];
					$scope.tipoAcessoFonte.push(-1);
					$scope.tipoAcessoFonte.push(-2);

					$timeout(function() {
						var userLogin = document.getElementById('createCatchLogin');

						if (userLogin) {
							userLogin.focus();
						}
					});
				} else if (selectedItem && selectedItem.idTipoAcessoFontePesq == -3) {
					$scope.tipoAcessoFonte = [];
					$scope.tipoAcessoFonte.push(-3);
				} else if (selectedItem && selectedItem.idTipoAcessoFontePesq == -5) {
					$scope.tipoAcessoFonte = [];
					$scope.tipoAcessoFonte.push(-5);
					$scope.tipoAcessoFonte.push(-3);
				} else {
					$scope.tipoAcessoFonte = [];
					// $scope.tipoAcessoFonte.push(-3);
				}
			};

			$scope.changeInput = value => {
				value == 'login'
					? ($scope.changelogin = true)
					: ($scope.changePassword = true);
			};

			$scope.showPassword = () => {
				$scope.inputType1 =
					$scope.inputType1 === 'password' ? 'text' : 'password';
			};

			$scope.getSystem = () => {
				$scope.recordSystem($scope.systemJudicial);
			};

			if ($stateParams.sistema) $scope.recordSystem($scope.systemJudicial);

			$scope.isMobile =
				window && window.innerWidth && window.innerWidth <= 991 ? true : false;

			$(window).resize(() => {
				let previousIsMobile = $scope.isMobile;

				$scope.isMobile = window.innerWidth <= 991;

				if ($scope.isMobile != previousIsMobile) {
					$scope.$apply();
				}
			});
		}
	])
	.filter('capitalize', () => {
		return capitalize;
	});

const REGEX_ALL = /([^\W_]+[^\s-]*) */g;
const REGEX_FIRST = /([^\W_]+[^\s-]*)/;

const capitalize = (input, all) => {
	if (!input) return '';

	const regex = all ? REGEX_ALL : REGEX_FIRST;

	return input.replace(
		regex,
		txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
	);
};

export default controller;
